'use client';

import { env } from 'next-runtime-env';
import { prefetchDNS } from 'react-dom';

const Prefetch = () => {
  const imgCdn = env('NEXT_PUBLIC_IMGIX_HEALTH_DOMAIN');

  if (imgCdn) {
    prefetchDNS(`https://${imgCdn}`);
  }

  prefetchDNS('https://cdn.segment.com');
  prefetchDNS('https://prodregistryv2.org');

  return null;
};

export default Prefetch;
